"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, LifeBuoy } from "lucide-react";
import Link from "next/link";
import { PageEyebrow } from "@/components/public/page-eyebrow";
import { PUBLIC_CONTAINER, PUBLIC_PANEL_RADIUS, PUBLIC_SECTION_PY_CONTENT } from "@/components/public/public-layout-styles";
import { SupportForm, type SupportFormValues, type SupportSubmitResult } from "@/components/support/support-form";
import { cn } from "@/lib/utils";
const UNAVAILABLE_MESSAGE = "Não foi possível enviar agora. Tente novamente em alguns minutos ou escreva diretamente para nosso e-mail.";
async function sendSupportMessage(values: SupportFormValues): Promise<SupportSubmitResult> {
  try {
    const response = await fetch("/api/support", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(values)
    });
    if (response.ok) return {
      ok: true
    };
    return {
      ok: false,
      message: response.status === 400 ? "Revise os campos e tente novamente." : UNAVAILABLE_MESSAGE
    };
  } catch {
    return {
      ok: false,
      message: UNAVAILABLE_MESSAGE
    };
  }
}
export function SupportPageContent() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn(PUBLIC_CONTAINER, "max-w-3xl", PUBLIC_SECTION_PY_CONTENT);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link className="text-muted-foreground hover:text-foreground mb-8 inline-flex items-center gap-2 text-sm transition-colors" href="/faq"><ArrowLeft className="size-4" />Voltar para a central de ajuda</Link>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-12"><PageEyebrow className="mb-4" icon={LifeBuoy}>Central de ajuda</PageEyebrow><h1 className="mb-4 max-w-[35ch] text-4xl font-semibold tracking-tight text-balance">Fale com o suporte</h1><p className="text-muted-foreground max-w-[52ch] text-pretty">Conte o que aconteceu. Respondemos por e-mail, sem precisar criar uma conta.</p></div>;
    t3 = <div className={cn("border-border/50 bg-card/50 border p-6 sm:p-8", PUBLIC_PANEL_RADIUS)}><SupportForm onSubmit={sendSupportMessage} surface="public" /></div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <main className="relative z-10"><div className={t0}>{t1}{t2}{t3}<p className="text-muted-foreground mt-8 text-base text-pretty sm:text-sm">Prefere escrever diretamente? Envie um e-mail para{" "}<a className="text-foreground underline underline-offset-4" href="mailto:contato@agroproj.com">contato@agroproj.com</a>.</p></div></main>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}